import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export type GetConversationByToken = (
  token: string,
) => Promise<{ data: Conversation }>;

export default (makeCall: MakeCall) => (token: string) =>
  makeCall<Conversation>('GET', `/api/v2/conversations/token/${token}`);
